import { render, staticRenderFns } from "./PlatformCustomer.vue?vue&type=template&id=6db0893c&scoped=true"
import script from "./PlatformCustomer.vue?vue&type=script&lang=js"
export * from "./PlatformCustomer.vue?vue&type=script&lang=js"
import style0 from "./PlatformCustomer.vue?vue&type=style&index=0&id=6db0893c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0893c",
  null
  
)

export default component.exports